import { render, staticRenderFns } from "./alertEmptyFile.vue?vue&type=template&id=285c7884"
import script from "./alertEmptyFile.vue?vue&type=script&lang=js"
export * from "./alertEmptyFile.vue?vue&type=script&lang=js"
import style0 from "./alertEmptyFile.vue?vue&type=style&index=0&id=285c7884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports